export const createRewriteTextRequest = (text) => {
  return {
    url: "/ai/rewrite",
    method: "POST",
    data: {
      text,
    },
  };
};

export const createGeneratePostsRequest = (instructions, tone) => {
  return {
    url: "/ai/generate_posts_streaming",
    method: "POST",
    data: {
      instructions,
      tone,
    },
    disableLoading: true,
  };
};

export const createChatRequest = (prompt, params) => {
  return {
    url: "/ai/chat",
    method: "POST",
    data: {
      prompt,
      params,
    },
  };
};

export const createGeneratePostRequest = (params) => {
  return {
    url: "/ai/generate_post",
    method: "POST",
    data: {
      params,
    },
  };
};

export const createGeneratePostFromTopicRequest = (topic) => {
  return {
    url: "/ai/generate_post_from_topic",
    method: "POST",
    data: {
      topic,
    },
  };
};

export const createGeneratePostIdeasRequest = (industry, useLatestNews) => {
  return {
    url: "/ai/generate_post_ideas",
    method: "POST",
    data: {
      industry,
      use_latest_news: useLatestNews,
    },
  };
};

export const createGeneratePostScoreRequest = (post) => {
  return {
    url: "/ai/generate_post_score/v2",
    method: "POST",
    data: {
      post,
    },
    disableLoading: true,
  };
};

export const createGenerateCarouselContentRequest = (
  post,
  slidesFormat,
  numberOfSlides
) => {
  let slides_format = slidesFormat;
  let number_of_slides = numberOfSlides;
  return {
    url: "/ai/generate_carousel_content",
    method: "POST",
    data: {
      post,
      slides_format,
      number_of_slides,
    },
    disableLoading: true,
  };
};

export const createGetPostRewriteTemplates = (disableLoading = false) => {
  return {
    url: "/post_rewrite_templates",
    method: "GET",
    disableLoading,
  };
};

export const createRewriteTextRequestV2 = (text, template_id) => {
  return {
    url: "/ai/rewrite/v2",
    method: "POST",
    data: {
      text,
      template_id,
    },
  };
};

export const createGenerateCommentRequest = (
  tone_id,
  comment_type_id,
  post_content,
  instructions,
  post_author_name = null
) => {
  return {
    url: "/ai/generate_comments",
    method: "POST",
    data: {
      tone_id,
      comment_type_id,
      post_content,
      instructions,
      post_author_name,
    },
  };
};

export const createGenerateImageRequest = (post) => {
  return {
    url: "/ai/generate_image",
    method: "POST",
    data: {
      post,
    },
  };
};

export const createAIHookGenerationRequest = (
  post_content,
  number_of_hooks
) => {
  return {
    url: "/ai/generate_hooks",
    method: "POST",
    data: {
      post_content,
      number_of_hooks,
    },
  };
};

export const createPerformNotesQuickActionRequest = (
  ai_quick_action_id,
  user_inputs,
  generation_type,
  content_writing_style_id
) => {
  return {
    url: "/ai/perform_notes_quick_action",
    method: "POST",
    data: {
      ai_quick_action_id,
      user_inputs,
      generation_type,
      content_writing_style_id,
    },
  };
};
